var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "993.01 493.01 513.99 513.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1399.91,939c-11.63,0-22.06-6.48-27.21-16.92l-184.43-374.21c-16.67-33.83-50.47-54.84-88.19-54.84h-107.06v149.3c0,25.42,10.1,49.8,28.07,67.78l39.91,39.91v-189h39.08c11.64,0,22.06,6.48,27.22,16.92l184.43,374.21c16.67,33.83,50.47,54.84,88.18,54.84h107.08v-149.29c0-25.42-10.1-49.8-28.07-67.78l-39.91-39.91v188.99h-39.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M993.02,857.69v149.29h107.06c37.72,0,71.52-21.01,88.19-54.84l27.33-55.45c9.74-19.78,9.74-42.94,0-62.72l-22.45-45.52-65.86,133.63c-5.15,10.44-15.57,16.92-27.22,16.92h-39.08v-188.99l-39.91,39.91c-17.98,17.98-28.07,42.36-28.07,67.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1399.91,493.02c-37.44,0-71.63,21.27-88.18,54.85l-27.33,55.44c-9.74,19.78-9.74,42.94,0,62.72l22.45,45.52,65.86-133.63c5.14-10.44,15.57-16.92,27.21-16.92h39.1v189l39.91-39.91c17.98-17.98,28.07-42.36,28.07-67.78v-149.3h-107.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logoIconWhite.dc532880700be43a364c67e2870dfb4d.svg";
export { ForwardRef as ReactComponent };